module.exports = __webpack_public_path__ + "img/ddef7e17.png";